<template>
    <nav class="navbar navbar-expand-sm navbar-light bg-white shadow-sm sticky-top">
        <div class="container">
            <router-link class="mx-auto navbar-brand" to="/">
                <img src="/img/identity/tgt_ro.png" alt="logo" height="30">
            </router-link>
        </div>
    </nav>
</template>
